package domain

import engine.model.GameSnapshot
import utils.formatTime
import kotlin.comparisons.maxOf

val COLORS: Map<Int, Int> = mapOf(

    -2 to 0x84ffff,  // I3 — pale cyan
    -1 to 0xb9f6ca,  // C  — pale mint

    1 to 0x00e5ff,  // I  — cyan
    2 to 0xffd600,  // O  — yellow
    3 to 0xaa00ff,  // T  — purple
    4 to 0x00e676,  // S  — green
    5 to 0xff1744,  // Z  — red
    6 to 0x2979ff,  // J  — blue
    7 to 0xff9100,  // L  — orange
    8 to 0xff4081,  // F  — hot pink
    20 to 0xff80ab,  // E  — soft pink
    9 to 0x18ffff,  // I5 — bright cyan

    10 to 0xffab40,  // L5 — light orange
    21 to 0xffd180,  // J5 — pale orange

    11 to 0x69f0ae,  // N  — mint
    24 to 0x1de9b6,  // S5 — teal

    12 to 0xea80fc,  // P  — lavender
    22 to 0xce93d8,  // Q  — soft violet

    18 to 0xa3f7bf,  // Y  — seafoam
    25 to 0x64ffda,  // H  — aqua

    19 to 0xff5252,  // Z5 — coral
    23 to 0xff6e40,  // R  — deep orange

    13 to 0x40c4ff,  // T5 — sky blue
    14 to 0xccff90,  // U  — lime
    15 to 0xffd740,  // V  — amber
    16 to 0x76ff03,  // W  — bright green
    17 to 0xe040fb,  // X  — magenta

    -99 to 0x444466, // garbage
)

enum class PlayGameMode { SPRINT, TIMEATTACK, STORY, CUSTOM }

data class GameModeConfig(
    val mode: PlayGameMode,
    val label: String,
    val color: Int,
    val goalLabel: String,
    val getGoalValue: (GameSnapshot) -> String,
    val getGoalRemaining: (GameSnapshot) -> String,
)

val MODE_CONFIGS: Map<PlayGameMode, GameModeConfig> = mapOf(
    PlayGameMode.SPRINT to GameModeConfig(
        mode = PlayGameMode.SPRINT,
        label = "SPRINT",
        color = 0x00e5ff,
        goalLabel = "LINES",
        getGoalValue = { "${it.hudInfo.totalLinesCleared}" },
        getGoalRemaining = { "${maxOf(0, 40 - (it.hudInfo.totalLinesCleared ?: 0))}" },
    ),
    PlayGameMode.TIMEATTACK to GameModeConfig(
        mode = PlayGameMode.TIMEATTACK,
        label = "TIME ATTACK",
        color = 0xffd600,
        goalLabel = "TIME",
        getGoalValue = { formatTime(it.hudInfo.sessionTimeSeconds ?: 0.0) },
        getGoalRemaining = { formatTime(maxOf(0.0, 120.0 - (it.hudInfo.sessionTimeSeconds ?: 0.0))) },
    ),
    PlayGameMode.CUSTOM to GameModeConfig(
        mode = PlayGameMode.CUSTOM,
        label = "CUSTOM",
        color = 0x00e676,
        goalLabel = "LINES",
        getGoalValue = { "${it.hudInfo.totalLinesCleared}" },
        getGoalRemaining = { "∞" },
    ),
    PlayGameMode.STORY to GameModeConfig(
        mode = PlayGameMode.STORY,
        label = "STORY",
        color = 0xaa00ff,
        goalLabel = "LINES",
        getGoalValue = { "${it.hudInfo.totalLinesCleared}" },
        getGoalRemaining = { "∞" },
    ),
)
